export function loadErrorMessage(error, subject) {
  if (!error.response) {
    return `We could not load ${subject}. Please check your connection and retry.`;
  }
  return `We could not load ${subject}. The service is unavailable. Please retry.`;
}

export function leadErrors(error) {
  if (error.response && error.response.status === 422) {
    return error.response.data.errors;
  }
  if (!error.response) {
    return { unknown: 'We could not save your quote. Please check your connection and try again.' };
  }
  return { unknown: 'We could not save your quote. Please try again.' };
}
